<div class="row">
  <div class="col-md-9">
    <h1 mat-dialog-title>Create Providers Info</h1>
  </div>
  <div class="col-md-3">
    <span class="pull-right f-13" (click)="closeDialog()"> X </span>
  </div>
</div>
<div mat-dialog-content>
  <form [formGroup]="managerMaintenanceForm" role="form">
    <div class="row mt-3">
      <!-- <div class="col-md-6">
        <label for="userId" class="control-label">ProviderCloudLogo</label>
        <input
          type="file"
          class="form-control"
          formControlName="uploadedImage"
          (change)="fileSelecte($event)"
          #UploadFileInput
        />
      </div> -->
      <div class="col-md-6">
        <label for="userId" class="control-label">PromoCode</label>
        <input type="text" class="form-control" formControlName="promoCode" />
      </div>
      <div class="col-md-6">
        <label for="userId" class="control-label">ProviderEmail</label>
        <input
          type="text"
          class="form-control"
          formControlName="providerEmail"
        />
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-6">
        <label for="userId" class="control-label">ProviderName</label>
        <input
          type="text"
          class="form-control"
          formControlName="providerName"
        />
      </div>
      <div class="col-md-6">
        <label for="userId" class="control-label">ProviderOperationHours</label>
        <input
          type="text"
          class="form-control"
          formControlName="providerOperationHours"
        />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6">
        <label for="userId" class="control-label">ProviderPhone</label>
        <input
          type="text"
          class="form-control"
          formControlName="providerPhone"
        />
      </div>
      <div class="col-md-6">
        <label for="userId" class="control-label">UtilityName</label>
        <input type="text" class="form-control" formControlName="utilityName" />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6">
        <label for="userId" class="control-label">RecipientEmail</label>
        <input
          type="text"
          class="form-control"
          formControlName="recipientEmail"
        />
      </div>
      <div class="col-md-6">
        <label for="userId" class="control-label">Status</label>
        <select class="form-control" formControlName="status">
          <option value=""></option>
          <option value="Active">Active</option>
          <option value="Inactive">Inactive</option>
          <!-- <option
            *ngFor="let providersStatusList of providersStatus"
            [ngValue]="providersStatusList.Status"
          >
            {{ providersStatusList.Status }}
          </option> -->
        </select>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6">
        <label for="userId" class="control-label">UtilityContact</label>
        <input
          type="text"
          class="form-control"
          formControlName="utilityContact"
        />
      </div>
    </div>
    <div class="pull-right mt-2">
      <button
        class="mr-2 mt-0 btn sectbtn brdrRadius"
        (click)="postDataOfNewEnergyProvider()"
      >
        Submit
      </button>
      <button mat-raised-button (click)="closeDialog()">Cancel</button>
    </div>
  </form>
  <!-- <input matInput [(ngModel)]="data.animal"> -->
</div>
